<template>
  <v-container fluid>
    <v-dialog v-model="deleteMultipleDocuments" width="700">
      <v-card>
        <v-container>
          <v-layout row wrap justify-center align-center>
            <v-flex text-xs-center>
              <h3>Are you sure you want to delete <b>{{selectedDocuments.length}}</b> documents?</h3>
              <p>ALL references to these documents will be removed as well</p>
            </v-flex>
            <v-flex xs12 text-xs-left>
              <b>This will remove these documents:</b>
              <ul>
                <li v-for="item in selectedDocuments">{{item.prettyTitle}}</li>
              </ul>
              <br/><hr/><br/>
            </v-flex>
            <v-flex xs6 text-xs-left>
              <v-btn :disabled="waitingOnServer" color="red" dark small @click="deleteSelectedDocuments">Confirm Delete</v-btn>
            </v-flex>
            <v-flex xs6 text-xs-right>
              <v-btn :disabled="waitingOnServer"  color="green" dark small @click="deleteMultipleDocuments = false;">Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card>
      <v-card-title>
            <span class="title">{{title}} ({{documents.length}})
             </span>

        <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="search"></v-text-field>

        <v-spacer></v-spacer>
        <v-btn :disabled="!dangerousFunctionsEnabled" class="red lighten-1" small dark @click.native="rebuildSearchContent()">
          Rebuild (save) All
        </v-btn>
            <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn class="deep-orange darken-3" fab small dark @click.native="add">
              <v-icon>add</v-icon>
            </v-btn>
          </v-card-title>
        <v-flex>
          <v-flex v-if="selectedDocuments.length > 1">
            <v-btn @click="clearSelectedDocuments">Unselect All</v-btn>
            <v-btn color="red" dark @click="deleteMultipleDocuments = true">Delete Selected</v-btn>
          </v-flex>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="documents"
            item-key="id"
          :pagination.sync="pagination"
        >

          <template slot="items" slot-scope="props">
            <tr>
              <td v-for="header in headers" style="white-space: pre-line;">
                  {{ props.item[header.value] }}
              </td>
            <td class="text-xs-left">
              <v-btn class="blue" fab small dark  @click.native="preview(props.item)">
                <v-icon>preview</v-icon>
              </v-btn>
              <v-btn class="teal" fab small dark  @click.native="edit(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn class="cyan" fab small  @click.native="remove(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
              <td>
                <v-checkbox
                    primary
                    hide-details
                    v-model="props.item.checked"
                ></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
          {{pagination}}
        </v-flex>
      </v-card>
    </v-flex>
    <confirm-dialog :dialog="dialog" :dialogTitle="dialogTitle" :dialogText="dialogText" @onConfirm="onConfirm" @onCancel="onCancel" ></confirm-dialog>
  </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import SearchPanel from "@/components/SearchPanel.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";
import moment from 'moment'

export default {
  components: {
    SearchPanel,
    ConfirmDialog
  },
  data () {
    return {
      deleteMultipleDocuments: false,
      waitingOnServer: false,
      title: '',
      dialog: false,
      dialogTitle: "Delete Document",
      dialogText: "Do you want to delete this document?",
      rightDrawer: false,
      right: true,
      search: sessionStorage.getItem(this.$route.params.type + '_search'),
      orderId: "",
      itemToDelete: null,
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
      pagination: JSON.parse(sessionStorage.getItem(this.$route.params.type + '_pagination')),
      watchpagination: false
    }
  },
  methods: {
    print () {
      window.print()
    },
    preview(item) {
      let documentViewRoute = this.$router.resolve({name: 'ViewDocument', params: {type: this.$route.params.type, id: item.id}})
      window.open(documentViewRoute.href, '_blank');
    },
    edit (item) {
      this.$router.push({name: 'EditDocument', params: {type: this.$route.params.type, id: item.id}})
      //this.$router.push({name: 'doc', params: {type: "test", id: item.id}})
    },
    add () {
      this.$router.push({name: 'NewDocument', params: {type: this.$route.params.type}})
    },
    remove (item) {
      this.dialog = true;
      this.itemToDelete = item;
      this.itemToDelete.docType = this.$route.params.type

      if(this.itemToDelete.docType.includes('policy')) {
        this.itemToDelete.docType = 'policy'
      }
    },
    onConfirm () {
      this.$deleteDocument(this.itemToDelete)
      this.dialog = false;
    },
    onCancel () {
      this.orderId = "";
      this.dialog = false;
    },
    rebuildSearchContent() {
      var index = 0
      var realThis = this
      console.log('========START SEARCH CONTENT REBUILD========')

      var looper = setInterval(function(){
        if(realThis.documents.length > index) {
          let buildDoc = realThis.$getDocument(realThis.documents[index].id)
          realThis.$saveDocument(buildDoc, true)
          index++
        } else {
          console.log('========END SEARCH CONTENT REBUILD========')
          clearInterval(looper);
        }


      }, 250);

    },
    reloadData () {
      this.$fetchData()
    },
    cancelSearch () {
      this.rightDrawer = false;
    },
    clearSelectedDocuments(){
      this.documents.forEach(function(part, index) {
        this[index].checked = undefined;
      }, this.documents);
    },
    deleteSelectedDocuments(){
      this.waitingOnServer = true
      this.$deleteMultipleDocument({docType: this.$route.params.type}, this.selectedDocuments).then(()=>{
        this.deleteMultipleDocuments = false
        this.waitingOnServer = false
      })
    }
  },
  computed: {
    selectedDocuments(){
      let toReturn = []
      this.documents.filter((x)=>x.checked).forEach((doc)=>{

        switch (this.$route.params.type) {
          case 'eclippingsarchive':
            doc.prettyTitle =  doc.linkText;
            break;
          default:
            doc.prettyTitle = doc.id;
        }

        /*
        policy: "policies",
                publication: "publications",
                resource: "resources",
                servicemanual: "servicemanuals",
                "school law": "servicemanuals",
                leaderarchive: "leaderarchives",
                journalarchive: "journalarchives",
                weeklyadvocatearchive: "weeklyadvocatearchives",
                eclippingsarchive: "eclippingsarchives"
         */
        toReturn.push(doc)
      })
      return toReturn
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    dangerousFunctionsEnabled() {
      return (window.location.hash == "#danger")
    },
    documents() {
      if (this.$route.params.type === 'isdpolicy') {
        return this.$policies.filter((doc)=> doc.ischarter == 0);
      } else if (this.$route.params.type === 'charterpolicy') {
        return this.$policies.filter((doc)=> doc.ischarter == 1);
      } else if (this.$route.params.type === 'publication') {
        var toReturn = []
        this.$publications.forEach((publication)=>{
          let category = this.$resourceLibrary.schema.categories.find((x)=>x.id == publication.webcat)
          if(category != null)
            publication.webcatName = category.label
          else
            publication.webcatName = "--"
          toReturn.push(publication)
        });
        return toReturn;
      } else if (this.$route.params.type === 'servicemanual') {
        return this.$serviceManuals
      } else if (this.$route.params.type === 'resource') {
        let toReturn = []
        this.$resources.forEach((resource)=>{
          let catResult = this.$resourceLibrary.schema.categories.find((item)=>item.id == resource.webcat)
          if(catResult != undefined) {
            resource.librarycat = catResult.label
          } else {
            resource.librarycat = '--'
          }

          toReturn.push(resource)
        })
        return toReturn
      } else if (this.$route.params.type === 'leaderarchive') {
        var toReturn = []
        var realThis = this
        this.$leaderArchives.forEach((leader)=>{
          leader.featuredArticleTitle = ""
          let whitespace = ""
          leader.featuredArticles.forEach((article)=>{
            let doc = realThis.$getDocument(article)
            let title = ''
            if(doc != undefined)
              title = doc.title
            leader.featuredArticleTitle = leader.featuredArticleTitle + whitespace + title
            whitespace = "\n"
          })
          toReturn.push(leader)
        })
        return toReturn
      } else if (this.$route.params.type === 'journalarchive') {
        let toReturn = []
        this.$journalArchives.forEach((item)=>{
          item.prettyMonth = moment(item.publicationDate).format('MMMM');
          item.prettyYear = moment(item.publicationDate).format('YYYY');
          toReturn.push(item)
        })

        console.log('the journalarchives are', toReturn)
        return toReturn
      } else if (this.$route.params.type === 'weeklyadvocatearchive') {

        let toReturn = []
        this.$weeklyAdvocateArchives.forEach((item)=>{
          item.prettyMonth = moment(item.publicationDate).format('MMMM');
          item.prettyYear = moment(item.publicationDate).format('YYYY');
          toReturn.push(item)
        })
        console.log('the weeklyadvocatearchive are', toReturn)
        return toReturn
      }  else if (this.$route.params.type === 'eclippingsarchive') {

        let toReturn = []
        this.$eclippingsArchives.forEach((item)=>{
          item.prettyMonth = moment(item.publicationDate).format('MMMM');
          item.prettyYear = moment(item.publicationDate).format('YYYY');
          toReturn.push(item)
        })
        console.log('the eclippingsArchives are', toReturn)
        return toReturn
      }
    },
        headers() {
      if (this.$route.params.type === 'isdpolicy' || this.$route.params.type === 'charterpolicy') {
        console.log('its policy', this.$route.params.type)
        return [
          {
            text: 'Title',
            value: 'title'
          },
          { text: 'Policy #', value: 'num' },
          { text: 'Series #', value: 'series' },
          { text: 'Type', value: 'type' },
          { text: 'Annual Review', value: 'annualreview' },
          { text: 'Public', value: 'publicvisible' }
        ]
      } else if (this.$route.params.type === 'publication') {
        console.log('its publication')
        return [
          {
            text: 'Title',
            value: 'title'
          },
          { text: 'Type', value: 'type' },
          { text: 'Category', value: 'webcatName' },
          { text: 'Date', value: 'dateof' },
          { text: 'Public', value: 'publicvisible' }
        ]
      } else if (this.$route.params.type === 'resource') {
        console.log('its resource')
        return [
          {
            text: 'Title',
            value: 'title'
          },
          { text: 'Type', value: 'type' },
          { text: 'Library Cat', value: 'librarycat' },
          { text: 'Date', value: 'dateof' },
          { text: 'Public', value: 'publicvisible' }
        ]
       } else if (this.$route.params.type === 'servicemanual') {
        return [
          {
            text: 'Citation',
            value: 'citation'
          },
          { text: 'Type', value: 'revtype' },
          { text: 'Number', value: 'revnumber' },
          { text: 'description', value: 'description' },
          { text: 'Public', value: 'publicvisible' }
        ]


      } else if (this.$route.params.type === 'leaderarchive') {
        console.log('its leader')
        return [
          {
            text: 'Featured Article',
            value: 'featuredArticleTitle'
          },
          { text: 'Date', value: 'publicationDate' },
        ]
      } else if (this.$route.params.type === 'journalarchive') {
        console.log('its resource')
        return [
          {
            text: 'Month',
            value: 'prettyMonth'
          },
          {
            text: 'Year',
            value: 'prettyYear'
          },
          { text: 'Date', value: 'publicationDate' },
        ]
      } else if (this.$route.params.type === 'weeklyadvocatearchive') {
        console.log('its weeklyadvocatearchive')
        return [
          {
            text: 'Title',
            value: 'linkText'
          },
          {
            text: 'Month',
            value: 'prettyMonth'
          },
          {
            text: 'Year',
            value: 'prettyYear'
          },
          { text: 'Date', value: 'publicationDate' },
        ]
      } else if (this.$route.params.type === 'eclippingsarchive') {
        console.log('its weeklyadvocatearchive')
        return [
          {
            text: 'Title',
            value: 'linkText'
          },
          {
            text: 'Source',
            value: 'sourceName'
          },
          { text: 'Date', value: 'publicationDate' },
        ]
      }
    }
  },
  watch: {
    search: function (val) {
      sessionStorage.setItem(this.$route.params.type + '_search', val);
    },
    pagination: function (val) {
      console.log('pagination changed', val)
      if(this.watchpagination) {
        console.log('updating...')
        sessionStorage.setItem(this.$route.params.type + '_pagination', JSON.stringify(val));
      }
      else {
        this.watchpagination = true
      }
    },
  },
  created () {
  },
  mounted () {

    if (this.$route.params.type === 'isdpolicy') {
      this.title = 'ISD Policies'
    } else if (this.$route.params.type === 'charterpolicy') {
      this.title = 'Charter Policies'
    } else if (this.$route.params.type === 'publication') {
      this.title = 'Publications'
    } else if (this.$route.params.type === 'resource') {
      this.title = 'Resources'
    } else if (this.$route.params.type === 'servicemanual') {
      this.title = 'School Law'
    }  else if (this.$route.params.type === 'journalarchive') {
      this.title = 'Journal Archives'
    }  else if (this.$route.params.type === 'leaderarchive') {
      this.title = 'Leader Newsletter Archives'
    }  else if (this.$route.params.type === 'weeklyadvocatearchive') {
      this.title = 'Weekly Advocate Archives'
    } else if (this.$route.params.type === 'eclippingsarchive') {
      this.title = 'eClipping Archives'
    } else {
      this.title = 'All Documents'
    }

    this.$nextTick(() => {
      console.log(this.headers);
    })
  }
}
</script>
